const BACKEND_URL = (process.env.REACT_APP_URL_BASE || '').replace(/\/$/, '')
const STATIC_URL = (
  process.env.REACT_APP_STATIC_URL ||
  process.env.REACT_APP_URL_BASE ||
  ''
).replace(/\/$/, '')

const isAbsoluteUrl = value => /^https?:\/\//i.test(String(value || ''))

/**
 * Construye la URL de una imagen de árbol a través del proxy del backend.
 * @param {string} r2Key - Clave R2 guardada en tb_tree_photos.filename
 *                         ej: 'arbolec/loja/trees/{id}/0_timestamp.webp'
 * @returns {string}
 */
export function getTreeImageUrl(r2Key) {
  if (!r2Key) return ''
  return `${BACKEND_URL}/tree-photos/proxy/${r2Key}`
}

/**
 * Resuelve la URL de una foto de árbol soportando el storage anterior
 * (/public/{treeId}/{filename}) y las claves actuales de R2 vía proxy.
 *
 * @param {number|string} treeId
 * @param {string} filename
 * @returns {string}
 */
export function getTreePhotoUrl(treeId, filename) {
  const photoKey = String(filename || '')
  if (!photoKey) return ''
  if (isAbsoluteUrl(photoKey)) return photoKey
  if (photoKey.includes('/')) return getTreeImageUrl(photoKey)
  if (!treeId) return ''
  return `${STATIC_URL}/tree-photos/public/${treeId}/${photoKey}`
}
